module.exports = __webpack_public_path__ + "img/c02_unitstartechaxemanchampion_Normal_ua.86e27f6f.webp";